export default __webpack_public_path__ + "static/media/faction-na.f08e8b98.png";